import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Follow_up_payment_receipt } from '../models/follow_up_payment_receipt';
import { Bill_item } from '../models/accounting/bill_item';
import { Store_payment_object } from '../models/accounting/store/store_payment_object';
import { Store_payment_response } from '../models/accounting/store/store_payment_response';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient) { }

  submitPendingEntriesPayment(order_uuid: string, payment_token: string, customer_id: string, amount: number, horse_show_id: string, entry_id_list: string[], additional_item_list: Bill_item[]): Promise<Follow_up_payment_receipt> {

  	 let post_data = {
                data: {
                  type: 'pending_entry_payment',
                  attributes: { order_uuid: order_uuid,
                  	token: payment_token,
                  	customer_id: customer_id,
                  	amount: amount,
                  	horse_show_id: horse_show_id,
                  	horse_show_entry_id_list: entry_id_list,
                  	additional_items: additional_item_list }
                  }
              };

              return new Promise((resolve, reject) => {

	             return this.http.post(AppSettings.API_ENDPOINT + 'accounting/pending_entry_payment',
	                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response:any) => {

	                     if(response.data && response.type=='follow_up_payment_receipt') {
	                         resolve(response.data);
	                       } else {
	                         if(response.text){
	                           reject(response.text);
	                         } else {
	                          reject(response);
	                        }
	                       }

	                }, error => {
	                  if(error instanceof HttpErrorResponse){
	                    reject(error.error);
	                  } else {
	                    reject(error.data ? error.data : error);
	                  }
	             });

        });


  }

  submitAcceptedEntriesPayment(order_uuid: string, payment_token: string, customer_id: string, amount: number, horse_show_id: string, entry_id_list: string[], additional_item_list: Bill_item[]): Promise<Follow_up_payment_receipt> {

  	 let post_data = {
                data: {
                  type: 'accepted_entry_payment',
                  attributes: { order_uuid: order_uuid,
                  	token: payment_token,
                  	customer_id: customer_id,
                  	amount: amount,
                  	horse_show_id: horse_show_id,
                  	horse_show_entry_id_list: entry_id_list,
                  	additional_items: additional_item_list }
                  }
              };

              return new Promise((resolve, reject) => {

	             return this.http.post(AppSettings.API_ENDPOINT + 'accounting/accepted_entry_payment',
	                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response:any) => {

	                     if(response.data && response.type=='follow_up_payment_receipt') {
	                         resolve(response.data);
	                       } else {
	                         if(response.text){
	                           reject(response.text);
	                         } else {
	                          reject(response);
	                        }
	                       }

	                }, error => {
	                  if(error instanceof HttpErrorResponse){
	                    reject(error.error);
	                  } else {
	                    reject(error.data ? error.data : error);
	                  }
	             });

        });


  }

  submitStorePayment(store_payment_object: Store_payment_object, nonce: string, device_data: string): Promise<Store_payment_response> {

			let post_data = {
          data: {
            type: 'store_payment_request',
            attributes: { store_payment_object: store_payment_object,
            	nonce: nonce,
            	device_data: device_data }
            }
        };

      return new Promise((resolve, reject) => {
      	return this.http.post(AppSettings.API_ENDPOINT + 'store/place_store_order',
	                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response:any) => {

	                     if(response.data && response.type=='store_payment_response') {
	                         resolve(response.data);
	                       } else {
	                         if(response.text){
	                           reject(response.text);
	                         } else {
	                          reject(response);
	                        }
	                       }

	                }, error => {
	                  if(error instanceof HttpErrorResponse){
	                    reject(error.error);
	                  } else {
	                    reject(error.data ? error.data : error);
	                  }
	             });
      });

  }


}
